






















































import {
  Component,
  Vue,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";
import { namespace } from "vuex-class";
import Loader from "@/components/Loader.vue";
import PropertyDeviceQualityArrivalPerformanceTable from "@/components/dashboard/PropertyDeviceQualityArrivalPerformanceTable.vue";
import { formatService } from "../../services/format.service";
import { IProperty } from "../../models/interfaces/property/property.model.interface";
import { IZonePerformanceSummary } from "@/models/interfaces/performance/zone-performance-summary.model.interface";


const PropertyPerformanceModule = namespace("propertyPerformanceModule");
const PublisherModule = namespace("publisherModule");
const UserSelectionModule = namespace("userSelectionModule");
const ZoneEnquiryModule = namespace("zoneEnquiryModule");
const UserModule = namespace("userModule");

@Component({
  components: {
    Loader,
    "device-performance" : PropertyDeviceQualityArrivalPerformanceTable
  }
})
export default class PropertyQualityArrivalPerformanceTable extends Vue {

  @Provide() public currentPage = 1;
  @Provide() public perPage = 10;
  @Provide() public totalRows = 0;

  get getSelectedProperty(): IProperty | null {
    return this.selectedProperty;
  }

  get getDates(): Date {
    return this.selectedDates;
  }

  get zonesOverview(): IProperty | null {
    return this.propertyZoneQualityArrivalPerformance;
  }

  get showPagination(): boolean {
    return this.items.length > this.perPage;
  }

  public getRowCount(items) {
    return items.length;
  }

  @UserModule.Getter public isAdmin;
  @PropertyPerformanceModule.Getter public propertyZoneDeviceQualityArrivalPerformance;
  @PropertyPerformanceModule.Action public retrievePropertyZoneQualityArrivalPerformance;
  @PropertyPerformanceModule.Action public retrievePropertyZoneDeviceQualityArrivalPerformance;
  @PropertyPerformanceModule.Getter public propertyZoneQualityArrivalPerformance;
  @PropertyPerformanceModule.Getter public zoneLoadsCount;
  @PropertyPerformanceModule.Getter public zoneImpressionCount;
  @PropertyPerformanceModule.Getter public zoneClicksCount;
  @UserSelectionModule.Getter public selectedDates;
  @PublisherModule.Getter public selectedProperty: IProperty | null;
  @ZoneEnquiryModule.Action public retrieveZoneEnquiryPerformance;

  @Prop({ default: "Table" })
  public caption: string;

  @Prop({ default: false })
  public hover: boolean;

  @Prop({ default: false })
  public striped: boolean;

  @Prop({ default: false })
  public bordered: boolean;

  @Prop({ default: false })
  public small: boolean;

  @Prop({ default: false })
  public fixed: boolean;

  @Prop({ default: false })
  public revenueAccess: boolean;

  @Provide() public property: IProperty | null = null;

  @Provide() public items: IZonePerformanceSummary[] = [];

  @Provide()
  public columns = [
    {
      key: "zone",
      label: "Zone",
      sortable: true,
      formatter: (value, key, item) => {
        return value;
      }
    },
    {
      key: "loads",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumber(value);
      }
    },
    {
      key: "impressions",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.impressions,
          item.loads
        );
      }
    },
    {
      key: "keyPresses",
      label: "Engagements",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.keyPresses,
          item.impressions
        );
      }
    },
        {
      key: "clicks",
      label: "Clicks",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.clicks,
          item.impressions
        );
      }
    },
    { key: "actions", label: "Actions" }
  ];

  public calculatePropertyTotal(key: string): number {
    if (!this.items) {
      return 0;
    }

    return this.items.map(i => i[key]).reduce((a, b) => a + b, 0);
  }

  public get loadsTotal(): number {
    return this.calculatePropertyTotal('loads');
  }

  public get impressionsTotal(): number {
    return this.calculatePropertyTotal('impressions');
  }

  public get keyPressesTotal(): number {
    return this.calculatePropertyTotal('keyPresses');
  }

  public get clicksTotal(): number {
    return this.calculatePropertyTotal('clicks');
  }

  public get loadsTotalFormatted(): string {
    return formatService.formatNumber(this.loadsTotal);
  }

  public get impressionsTotalFormatted(): string {
    return formatService.formatNumberPercentage(this.impressionsTotal, this.impressionsTotal, this.loadsTotal);
  }

  public get keyPressesTotalFormatted(): string {
    return formatService.formatNumberPercentage(this.keyPressesTotal, this.keyPressesTotal, this.impressionsTotal);

  }

  public get clicksTotalFormatted(): string {
    return formatService.formatNumberPercentage(this.clicksTotal, this.clicksTotal, this.impressionsTotal);
  }

  private showDeviceTable: boolean = false;

  private loading: boolean = true;

  @Watch("getSelectedProperty")
  public onSelectedPropertyChanged() {
    this.property = this.getSelectedProperty;
    this.updatePerformanceData();
  }

  @Watch("selectedDates")
  public onDatesChanged() {
    this.updatePerformanceData();
  }

  @Watch("zonesOverview")
  public onOverviewChanged() {
    this.items = this.propertyZoneQualityArrivalPerformance.filter((x) => x.zone !== null);
  }

  public buttonToggled() {
    this.showDeviceTable = !this.showDeviceTable;
  }

  public updatePerformanceData() {
    this.loading = true;
    if (this.property) {

      Promise.race([
        this.retrievePropertyZoneQualityArrivalPerformance(this.property.propertyId),
        this.retrievePropertyZoneDeviceQualityArrivalPerformance(this.property.propertyId)
      ]).then((result) => {
          if (result) {
            this.items = this.propertyZoneQualityArrivalPerformance.filter((x) => x.zone !== null);
          }

          this.loading = false;
        }
      );
    }

  }

 public created() {
    this.property = this.getSelectedProperty;
    this.updatePerformanceData();
  }
}
